import { Session } from '@app/classes/user/session';
import { HttpHeaders } from '@angular/common/http';
import { AppSettings } from '@app/helpers/app.settings';
import { environment } from '@env/environment';
export class Service {
    get API_ENDPOINT_SOCIAL() {
        return environment.baseUrlSlim;
    }
    get API_ENDPOINT() {
        return AppSettings.API_ENDPOINT;
    }
    get APP_REQUEST_OPTIONS() {
        return AppSettings.APP_REQUEST_OPTIONS;
    }
    get API_ENDPOINT_API_INTERSOCIO() {
        return AppSettings.API_ENDPOINT_API_INTERSOCIO;
    }
    get API_ENDPOINT_API_INTER() {
        return AppSettings.API_ENDPOINT_API_INTER;
    }
    get APP_REQUEST_OPTIONS_AUTH() {
        const systemSession = Session.getInstance();
        const headers = new HttpHeaders({
            authorization: systemSession.getSessionAuthorization() || '',
        });
        return {
            headers
        };
    }
}
//# sourceMappingURL=Service.js.map